import { render, staticRenderFns } from "./pollList.vue?vue&type=template&id=2382fe3d"
import script from "./pollList.vue?vue&type=script&lang=js"
export * from "./pollList.vue?vue&type=script&lang=js"
import style0 from "./pollList.vue?vue&type=style&index=0&id=2382fe3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports